const nf = new Intl.NumberFormat("ko-KR");

export const fmtNum = (v: number) => nf.format(Math.round(v));
export const fmtPrice = (v: number, decimals = 2) => v.toFixed(decimals);
export const fmtPct = (v: number | null, d = 1) => (v == null ? "–" : `${(v * 100).toFixed(d)}%`);
export const fmtRatio = (v: number | null, d = 2) => (v == null ? "–" : v.toFixed(d));

// 원 → 억원
export function fmtEok(v: number, d = 1) {
  const x = v / 1e8;
  return `${x > 0 ? "+" : x < 0 ? "−" : ""}${Math.abs(x).toFixed(d)}억`;
}
